<template>
    <hb-modal v-model="dialog" v-if="dialog" :confirmation="true" size="medium" :title="title" show-help-link @close="$emit('close')" :footerCancelOption="!showCloseBtn">
      <template v-slot:content>
        <div v-if="loader" class="ti-widget" style="height:200px">
          <v-row justify="center" align="center" class="pa-0 ma-0">
              <v-col class="text-center ma-12">
                <v-progress-circular width="2" size="32" indeterminate color="primary" ></v-progress-circular>
              </v-col>
          </v-row>
        </div>
        <div v-else class="ma-4">
            <div class="mb-3" v-if="primaryContent"><strong>{{ primaryContent }}</strong></div>
            <div class="mb-3" v-if="displayNewContact">
              <hb-card title="Contact Information" class="mt-4">
                <hb-form label="Name" v-if="newContact?.first || newContact?.last">
                  <span>{{ newContact.first }} {{ newContact.last }}</span> 
                </hb-form>

                <hb-form label="Email" v-if="newContact?.email">
                  <span>{{ newContact.email }}</span>
                </hb-form>

                <hb-form label="Phone" v-if="newContact?.Phone?.phone">
                  <span class="pr-2">{{ (newContact.Phone.type) }}</span>{{ newContact.Phone.phone | formatPhone}}
                </hb-form>
              </hb-card>
            </div>

            <div class="mb-3" v-if="secondaryContent" ><strong>{{ secondaryContent }}</strong></div>
            <v-row v-for="(contact, index) in contacts" :key="contact?.id + '_' + index" class="mb-3" no-gutters>
              <v-col v-if="allowMultiSelect && contact?.id" class="col-1">
                <hb-checkbox
                  v-model="selectedContacts[index]"
                  hide-details
                />
              </v-col>
              <v-col :class="allowMultiSelect ? 'col-11' : 'col-12'">
                <mini-profile-view
                    v-if="contact?.id"
                    :contact-id="contact.id"
                    :tenant-profile="true"
                    :use-contact="false"
                    :contact-data="contact"
                />

                <v-progress-circular v-else width="2" size="32" indeterminate color="primary" ></v-progress-circular>
                <div class="mt-3" v-if="isTenantInDoNotRentList(contact)?.reason || contact?.reason">
                    <strong>Reason:</strong> {{ isTenantInDoNotRentList(contact).reason || contact?.reason }}
                </div>
                <v-divider v-if="contacts.length > 1 && index < contacts.length - 1" class="mt-3 mb-3"></v-divider>
              </v-col>
            </v-row>
            <hb-notification
                notDismissable
                v-model="notification1"
                v-if="popupContext != 'dnr_tool' ? !hasPermission('move_in_do_not_rent') && !softMatch : !hasPermission('add_to_do_not_rent_list')"
                type="caution"
            >
            {{ TENANT.DNR.PERMISSION }} 
            </hb-notification>
            <span v-else>{{ confirmationText }}</span>
         </div> 
      </template>
      <template v-slot:right-actions>
        <hb-btn
          color="primary"
          :loading="loader || miniProfileContactLoader" 
          :disabled="loader || miniProfileContactLoader" 
          @click="processBtn"
          v-if="showProcessBtn && (popupContext != 'dnr_tool' ? (hasPermission('move_in_do_not_rent') || softMatch) : hasPermission('add_to_do_not_rent_list'))"
        >
          {{ btnText }}
        </hb-btn>
        <hb-btn
          color="secondary"
          :loading="loader || miniProfileContactLoader" 
          :disabled="loader || miniProfileContactLoader" 
          @click="$emit('close')"
          v-if="showCloseBtn && !showProcessBtn"
        >
          {{ btnText }}
        </hb-btn>
      </template>
    </hb-modal>
  </template>
  
  <script type="text/babel">
    import MiniProfileView from './LeadIntake/MiniProfileView.vue'
    import { mapGetters } from 'vuex';
    import { EventBus } from '../../EventBus.js';
    import TENANT from "@/constants/tenant.js";
    export default {
      name: "DoNotRentModal",
      data() {
        return {
          notification1: true,
          miniProfileContactLoader: false,
          selectedContacts: [],
        } 
      },
      props: {
        value: {
          type: Boolean,
          default: false
        },
        loader: {
          type: Boolean,
          default: false
        },
        contacts: {
          type: Array,
          default: [() => []]
        },
        btnText:{
          type: String,
          default: 'Continue'
        },
        confirmationText:{
          type: String,
          default: 'Do you still want to add a space?'
        },
        softMatch:{
          type: Boolean,
          default: false
        },
        returnMethod:{
          type: String,
          default: ''
        },
        title:{
          type: String,
          default: 'Do Not Rent'
        },
        primaryContent: {
          type: String,
          default: ''
        },
        allowMultiSelect: {
          type: Boolean,
          default: false
        },
        showProcessBtn: {
          type: Boolean,
          default: true
        },
        showCloseBtn: {
          type: Boolean,
          default: false
        },
        popupContext: {
          type: String,
          default: 'move_in'
        },
        secondaryContent: {
          type: String,
          default: ''
        },
        newContact: {
          type: Object,
          default: () => ({})
        }
      },
      components:{
          MiniProfileView
      },
      computed: {
        ...mapGetters({
          hasPermission: 'authenticationStore/rolePermission'
        }),
        dialog: {
          get () {
            return this.value
          },
          set (value) {
            this.$emit('input', value)
          }
        },
        displayNewContact(){
          return this.newContact?.email || this.newContact?.first || this.newContact?.last || this.newContact?.Phone?.phone
        }
      },
      created (){
        this.TENANT = TENANT;
        if(this.contacts.length > 0) {
          //this.miniProfileContactLoader = true;
          EventBus.$on("mini_profile_contact_loaded", this.miniProfileContactLoaded);   
        }
      },
      destroyed(){
        EventBus.$off("mini_profile_contact_loaded", this.miniProfileContactLoaded)
      },
      methods: {
        miniProfileContactLoaded(flag){
          if(flag){
            this.miniProfileContactLoader = false
          }
        },
        isTenantInDoNotRentList(contact) {
            return contact?.contactFlags?.length > 0 ?  contact?.contactFlags.find(flag => flag.slug == TENANT.TENANT_FLAGS.DO_NOT_RENT): {};
        },
        processBtn(){
          let payload = {
            flag: true,
            method: this.returnMethod,
            contactsToAdd: this.allowMultiSelect ? this.contacts.filter((contact, index) => !!this.selectedContacts[index]) : this.displayNewContact ? [] : this.contacts,
          };
          this.$emit('process', payload);
        }
      },
    }
  </script>